/** One message for "this isn't a PDF we can open", shared by every tool that previews a PDF. */
export const NOT_READABLE_PDF_TITLE = "This file isn't a readable PDF";

export function notReadableDetail(name: string): string {
  return `“${name}” could not be opened as a PDF. It may be damaged, cut short, or not a PDF at all. Try Repair PDF, or choose a different file.`;
}

/** True when pdf.js / pdf-lib failed because the file needs a password (so a different message applies). */
export function isPasswordError(err: unknown): boolean {
  const e = err as { name?: string; message?: string } | null;
  return e?.name === "PasswordException" || /password|encrypted/i.test(e?.message ?? "");
}
